import { useContext } from 'react';
import SettingsContext from 'src/contexts/SettingsContext';
import type { SettingsContextValue } from 'src/contexts/SettingsContext';

const useLocalSettings = (): SettingsContextValue => useContext(SettingsContext);
export default useLocalSettings;
